import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import {
    Home,
    Person,
    LocalMall,
    Grain,
    Inventory2,
    LocalShipping,
    Public,
    Category,
    LocalFireDepartment,
    Storage,
    EmojiNature, TaskAlt, HelpOutline,
} from '@mui/icons-material';

const useActiveItem = (path) => {
    const location = useLocation();
    return location.pathname === path;
};

export const MainListItems = ({ onClose }) => {
    const isActive = useActiveItem('/admin');
    return (
        <ListItemButton
            component={Link}
            to="../admin"
            selected={isActive}
            onClick={onClose}
            sx={{ '&.Mui-selected': { backgroundColor: '#e0e0e0' } }} // Выделение активного элемента
        >
            <ListItemIcon>
                <Home color="primary"/>
            </ListItemIcon>
            <ListItemText primary="home"/>
        </ListItemButton>
    );
};

export const UserListItems = ({ onClose }) => {
    const location = useLocation();
    const isActive = (path) => location.pathname === path;

    return (
        <>
            {!onClose || ( <ListItemButton
                component={Link}
                to="../admin/documentation"
                selected={isActive('/admin/documentation')}
                onClick={onClose}
                sx={{ '&.Mui-selected': { backgroundColor: '#e0e0e0' } }}
            >
                <ListItemIcon>
                    <HelpOutline color="primary"/>
                </ListItemIcon>
                <ListItemText primary="documentation"/>
            </ListItemButton> )
            }
            <ListItemButton
                component={Link}
                to="../admin/users"
                selected={isActive('/admin/users')}
                onClick={onClose}
                sx={{ '&.Mui-selected': { backgroundColor: '#e0e0e0' } }}
            >
                <ListItemIcon>
                    <Person color="primary"/>
                </ListItemIcon>
                <ListItemText primary="users"/>
            </ListItemButton>
            <ListItemButton
                component={Link}
                to="../admin/tasks"
                selected={isActive('/admin/tasks')}
                onClick={onClose}
                sx={{ '&.Mui-selected': { backgroundColor: '#e0e0e0' } }}
            >
                <ListItemIcon>
                    <TaskAlt color="primary"/>
                </ListItemIcon>
                <ListItemText primary="tasks"/>
            </ListItemButton>
            <ListItemButton
                component={Link}
                to="../admin/create-sticker"
                selected={isActive('/admin/create-sticker')}
                onClick={onClose}
                sx={{ '&.Mui-selected': { backgroundColor: '#e0e0e0' } }}
            >
                <ListItemIcon>
                    {/*<TaskAlt color="primary"/>*/}
                </ListItemIcon>
                <ListItemText primary="label creator"/>
            </ListItemButton>
        </>
    );
};

export const DataListItems = ({ onClose }) => {
    const location = useLocation();
    const isActive = (path) => location.pathname === path;

    return (
        <>
            <ListItemButton
                component={Link}
                to="../admin/bags"
                selected={isActive('/admin/bags')}
                onClick={onClose}
                sx={{ '&.Mui-selected': { backgroundColor: '#e0e0e0' } }}
            >
                <ListItemIcon>
                    <LocalMall color="primary"/>
                </ListItemIcon>
                <ListItemText primary="bags"/>
            </ListItemButton>
            <ListItemButton
                component={Link}
                to="../admin/batches"
                selected={isActive('/admin/batches')}
                onClick={onClose}
                sx={{ '&.Mui-selected': { backgroundColor: '#e0e0e0' } }}
            >
                <ListItemIcon>
                    <Grain color="primary"/>
                </ListItemIcon>
                <ListItemText primary="batches"/>
            </ListItemButton>
            <ListItemButton
                component={Link}
                to="../admin/orders"
                selected={isActive('/admin/orders')}
                onClick={onClose}
                sx={{ '&.Mui-selected': { backgroundColor: '#e0e0e0' } }}
            >
                <ListItemIcon>
                    <Inventory2 color="primary"/>
                </ListItemIcon>
                <ListItemText primary="orders"/>
            </ListItemButton>
            <ListItemButton
                component={Link}
                to="../admin/packs"
                selected={isActive('/admin/packs')}
                onClick={onClose}
                sx={{ '&.Mui-selected': { backgroundColor: '#e0e0e0' } }}
            >
                <ListItemIcon>
                    <LocalShipping color="primary"/>
                </ListItemIcon>
                <ListItemText primary="packs"/>
            </ListItemButton>
        </>
    );
};

export const ConstantListItems = ({ onClose }) => {
    const location = useLocation();
    const isActive = (path) => location.pathname === path;

    return (
        <>
            <ListItemButton
                component={Link}
                to="../admin/buckets"
                selected={isActive('/admin/buckets')}
                onClick={onClose}
                sx={{ '&.Mui-selected': { backgroundColor: '#e0e0e0' } }}
            >
                <ListItemIcon>
                    {/*<Public color="primary"/>*/}
                </ListItemIcon>
                <ListItemText primary="buckets"/>
            </ListItemButton>
            <ListItemButton
                component={Link}
                to="../admin/countries"
                selected={isActive('/admin/countries')}
                onClick={onClose}
                sx={{ '&.Mui-selected': { backgroundColor: '#e0e0e0' } }}
            >
                <ListItemIcon>
                    <Public color="primary"/>
                </ListItemIcon>
                <ListItemText primary="countries"/>
            </ListItemButton>
            <ListItemButton
                component={Link}
                to="../admin/processes"
                selected={isActive('/admin/processes')}
                onClick={onClose}
                sx={{ '&.Mui-selected': { backgroundColor: '#e0e0e0' } }}
            >
                <ListItemIcon>
                    <Category color="primary"/>
                </ListItemIcon>
                <ListItemText primary="processes"/>
            </ListItemButton>
            <ListItemButton
                component={Link}
                to="../admin/roast-types"
                selected={isActive('/admin/roast-types')}
                onClick={onClose}
                sx={{ '&.Mui-selected': { backgroundColor: '#e0e0e0' } }}
            >
                <ListItemIcon>
                    <LocalFireDepartment color="primary"/>
                </ListItemIcon>
                <ListItemText primary="roast types"/>
            </ListItemButton>
            <ListItemButton
                component={Link}
                to="../admin/types"
                selected={isActive('/admin/types')}
                onClick={onClose}
                sx={{ '&.Mui-selected': { backgroundColor: '#e0e0e0' } }}
            >
                <ListItemIcon>
                    <Storage color="primary"/>
                </ListItemIcon>
                <ListItemText primary="types"/>
            </ListItemButton>
            <ListItemButton
                component={Link}
                to="../admin/varieties"
                selected={isActive('/admin/varieties')}
                onClick={onClose}
                sx={{ '&.Mui-selected': { backgroundColor: '#e0e0e0' } }}
            >
                <ListItemIcon>
                    <EmojiNature color="primary"/>
                </ListItemIcon>
                <ListItemText primary="varieties"/>
            </ListItemButton>
        </>
    );
};
